function setHomeCarouselButtonState(button, disabled) {
  button.disabled = disabled;
  button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
  button.classList.toggle('is-disabled', disabled);
}

function updateHomeCarouselButtons(carousel, position) {
  var track = carousel.querySelector('[data-home-carousel-track]');
  var previousButton = carousel.querySelector('[data-home-carousel-previous]');
  var nextButton = carousel.querySelector('[data-home-carousel-next]');
  if (!track || !previousButton || !nextButton) return;

  var scrollLeft = typeof position === 'number' ? position : track.scrollLeft;
  var maxScroll = Math.max(track.scrollWidth - track.clientWidth, 0);
  carousel.classList.toggle('has-no-overflow', maxScroll <= 2);
  setHomeCarouselButtonState(previousButton, scrollLeft <= 2);
  setHomeCarouselButtonState(nextButton, scrollLeft >= maxScroll - 2);
}

function handleHomeCarouselClick(event) {
  var button = event.currentTarget;
  if (!button || button.getAttribute('aria-disabled') === 'true') return;

  var carousel = button.closest('[data-home-carousel]');
  var track = carousel && carousel.querySelector('[data-home-carousel-track]');
  var item = track && track.querySelector('[data-home-carousel-item]');
  if (!track || !item) return;

  var styles = window.getComputedStyle(track);
  var gap = parseFloat(styles.columnGap || styles.gap) || 0;
  var step = item.getBoundingClientRect().width + gap;
  var direction = button.hasAttribute('data-home-carousel-next') ? 1 : -1;
  track.scrollBy({ left: direction * step, behavior: 'smooth' });
}

function handleHomeCarouselScroll(event) {
  var track = event.target;
  if (!track.matches || !track.matches('[data-home-carousel-track]')) return;

  var carousel = track.closest('[data-home-carousel]');
  if (carousel) updateHomeCarouselButtons(carousel);
}

var homeCarouselResizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function(entries) {
  entries.forEach(function(entry) {
    var carousel = entry.target.closest('[data-home-carousel]');
    if (carousel) updateHomeCarouselButtons(carousel);
  });
}) : null;

function setupHomeCarousels() {
  document.querySelectorAll('[data-home-carousel]').forEach(function(carousel) {
    var track = carousel.querySelector('[data-home-carousel-track]');
    var previousButton = carousel.querySelector('[data-home-carousel-previous]');
    var nextButton = carousel.querySelector('[data-home-carousel-next]');
    if (!track || !previousButton || !nextButton) return;

    previousButton.onclick = handleHomeCarouselClick;
    nextButton.onclick = handleHomeCarouselClick;

    if (!track.homeCarouselScrollBound) {
      track.addEventListener('scroll', handleHomeCarouselScroll, { passive: true });
      track.homeCarouselScrollBound = true;
    }

    if (homeCarouselResizeObserver) homeCarouselResizeObserver.observe(track);

    updateHomeCarouselButtons(carousel);
  });
}

document.addEventListener('turbo:load', setupHomeCarousels);
window.addEventListener('resize', setupHomeCarousels);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupHomeCarousels, { once: true });
} else {
  setupHomeCarousels();
}
